var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.path)?_c('el-image',{staticClass:"uploaded-image",attrs:{"fit":_vm.fit,"src":_vm.path,"alt":_vm.alt,"lazy":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }